import React from "react"
import * as landingSectionImageRightStyles from "../../styles/landing_pages/LandingSectionImageRight.module.css"
import { ChildSelector } from "../../helpers/ChildSelector"
import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

export default function LandingSectionImageRight({
  content,
  className,
  pageContext,
}) {
  const title = ChildSelector.select(
    content,
    `section-image-right-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subtitle = ChildSelector.select(
    content,
    `section-image-right-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const info = content.childNodes
    .filter(node => node.classNames === "section-image-right-content")
    .map(t => t.innerHTML)

  const featuresList = ChildSelector.select(
    content,
    `list`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  return (
    <div
      className={`row ${className} ${landingSectionImageRightStyles.wrapper}`}
    >
      <div
        className={`col-12 col-lg-6 ${landingSectionImageRightStyles.contentWrapper}`}
      >
        {subtitle && (
          <h4
            className={landingSectionImageRightStyles.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
        <h1
          className={landingSectionImageRightStyles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={landingSectionImageRightStyles.textContent}>
          {info.map((text, idx) => (
            <p
              key={`content-${idx}`}
              dangerouslySetInnerHTML={{ __html: text }}
              className={landingSectionImageRightStyles.main}
            />
          ))}
          {featuresList?.childNodes?.length > 0 && (
            <ul className={`${landingSectionImageRightStyles.contentList}`}>
              {featuresList.childNodes.map((r, idx) => (
                <li
                  key={idx}
                  className={`${landingSectionImageRightStyles.listItem}`}
                  dangerouslySetInnerHTML={{ __html: r.innerHTML }}
                />
              ))}
            </ul>
          )}
        </div>
        <WPCta
          holder={content}
          selector="landing-image-right-cta"
          translate={true}
          className={landingSectionImageRightStyles.ctaBtn}
          pageContext={pageContext}
        />
      </div>

      <div
        className={`col-12 col-lg-6 ${landingSectionImageRightStyles.mediaWrapper}`}
      >
        <WPImage
          holder={content}
          selector="media-asset"
          mode={DISPLAY_MODE.normal}
          className={landingSectionImageRightStyles.image}
        />
      </div>
    </div>
  )
}
